module.exports = "/_next/static/media/Image-3.f402fd55.png";